window.addEventListener("DOMContentLoaded", function () {
  $(".our-products a.action_button").click(function () {
    let urlData = $(this).attr("data-name");
    let fname = "";
    let lname = "";
    let queryString = fname + "," + lname + "," + urlData;
    $(this).attr("href", "/pages/request-a-quote?datapass=" + queryString);
  });

  $(".btnMobile").on("click", function () {
    if ($(".mobile").css("display") == "none") {
      $(".mobile").fadeIn(500);
    } else {
      $(".mobile").fadeOut();
    }
  });

  $("#btnMobile").on("click", function () {
    $(this).toggleClass("btnClose");
  });

  $(".btnOpen1").on("click", function () {
    if ($(".boxAbout").css("display") == "none") {
      $(".boxAbout").slideDown(500);
    } else {
      $(".boxAbout").slideUp();
    }
  });
  $("#btnOpen1").on("click", function () {
    $(this).toggleClass("btnClose");
  });

  $(".btnOpen2").on("click", function () {
    if ($(".boxContact").css("display") == "none") {
      $(".boxContact").slideDown(500);
    } else {
      $(".boxContact").slideUp();
    }
  });
  $("#btnOpen2").on("click", function () {
    $(this).toggleClass("btnClose");
  });

  $(".btnOpen3").on("click", function () {
    if ($(".boxMenu").css("display") == "none") {
      $(".boxMenu").slideDown(500);
    } else {
      $(".boxMenu").slideUp();
    }
  });
  $("#btnOpen3").on("click", function () {
    $(this).toggleClass("btnClose");
  });

  $(".btnSidebar").on("click", function () {
    if ($(".default-sidebar, .custom-sidebar").css("display") == "none") {
      $(".default-sidebar, .custom-sidebar").slideDown(500);
    } else {
      $(".default-sidebar, .custom-sidebar").slideUp();
    }
  });
  $("#btnSidebar").on("click", function () {
    $(this).toggleClass("btnClose");
  });

  var viewport = $(window).width();
  if (viewport <= 1024) {
    jQuery(".parent").on("click", function () {
      jQuery("child").toggleClass("display");
    });
  }
});
